
<div class="container h-100 w-100">
    <div class="mx-auto d-flex justify-content-center align-items-center h-100">
        <div class="left-Side-cover w-50 h-100 d-none d-lg-block"></div>
    <div class="right-Side-cover w-50 h-100 d-none d-lg-block"></div>
    <div class="card mb-0 mx-auto w-75">
        <div class="row">
            <!-- Logo and card -->
            <div class="col-lg-6 col-sm-12">
                <div class="py-5  d-flex flex-column my-2">
                    <!-- Logo Div -->
                    <div class="text-center">
                        <img src="assets/caregenix/images/logo/svg-carevance-hori-logo.svg" alt="logo" class="logo-dark" />
                    </div>
                    <!-- Cards Container -->
                    <div class="text-center" [ngClass]="showErrorDiv?'py3':'pt-3 pb-2'">
                        <h2 class="text-password"> RESET PASSWORD </h2>
                    </div>
                    <div class="d-flex justify-content-center w-100" >
                        <div *ngIf="showErrorDiv" class="bg-danger-subtle d-flex justify-content-between p-1 w-75">
                            <div>
                                <span class="text-danger-emphasis">
                                    <i class="fs-3 ti ti-bomb"></i> {{ currentMessage }}
                                </span>
                            </div>
                            <div>
                                <button type="button" class="btn-close me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"
                                    (click)="close()"></button>
                            </div>
                        </div>
                    </div>
                    <div class="px-3">
                        <app-input-static-fields
                            htmlCode="" 
                            code="ti ti-mail"
                            [label]="translate('EMAILADDRESS')" 
                            code="fa fa-lock"
                            name="email"
                            type="text"
                            [formGroup]="resetPasswordForm"
                            formControlValue="email"
                            [isReadonly]="true"
                        />
                        <app-input-static-fields
                            [label]="translate('CHOOSEPASSWORD')" 
                            code="fa fa-lock"
                            name="Choose a password"
                            type="password"
                            [formGroup]="resetPasswordForm"
                            formControlValue="password"
                        />
                        <app-input-static-fields
                            [label]="translate('CONFIRMATIONCODE')" 
                            code="fa fa-lock"
                            name="Repeat password"
                            type="text"
                            [formGroup]="resetPasswordForm"
                            formControlValue="code"
                        />                        
                    </div>
                    
                    <div class="px-3 py-3">
                        <button type="submit" 
                         class="btn btn-lg w-100 btnChangePassword"
                         [disabled]="resetPasswordForm.invalid" 
                         (click)="onSubmit()"
                        >Change Password</button>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 bg-cover d-none d-lg-block p-0">
                <app-image-side customClass="" />
            </div>
        </div>
    </div>
</div>
